var map = {
	"./team_leader_1.png": "8c32",
	"./team_leader_2.png": "e13d",
	"./team_leader_3.png": "5982",
	"./team_leader_4.png": "3875",
	"./team_leader_5.png": "61b6",
	"./team_leader_6.png": "fa4e",
	"./team_leader_7.png": "13e6",
	"./team_leader_label.png": "c479"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9db6";